const clientSide = [
  "React",
  "JavaScript",
  "TypeScript",
  "Next.js",
  "HTML",
  "CSS",
  "MUI, Bulma, UIKit",
];

const serverSide = ["Node.js", "Express.js", "MySQL ", "DynamoDB", "MongoDB"];

const other = [
  "Jenkins",
  "Terraform",
  "AWS Lambda",
  "AWS API Gateway",
  "AWS S3",
  "AWS ECS",
];

const design = [
  "Figma",
  "Adobe InDesign",
  "Adobe Illustrator",
  "Responsive Web Design",
  "Sketchup",
  "AutoCAD",
];

export { clientSide, serverSide, design, other };
